module.exports = __webpack_public_path__ + "static/basen-prosto-4dab6085651cb4ee8630edfed7c80ec6.jpg";